module.exports = __webpack_public_path__ + "img/banker-gold_320.68d2f619.png";